export const QUESTIONS = [
  {
    id: 1,
    header: "What is Cryptocurrency?",
    text:
      "A cryptocurrency (or “crypto”) is a digital currency that can be used to buy goods and services, but uses an online ledger with strong cryptography to secure online transactions. ",
  },
  {
    id: 2,
    header: "What is blockchain technology?",
    text:
      "A blockchain is a digital record of transactions. The name comes from its structure, in which individual records, called blocks, are linked together in single list, called a chain.",
  },
  {
    id: 3,
    header: "How do I buy cryptocurrency?",
    text:
      "To buy cryptocurrencies, you’ll need a “wallet,” an online app that can hold your currency. Generally, you create an account on an exchange, and then you can transfer real money to buy cryptocurrencies such as Bitcoin or Ethereum.",
  },
  {
    id: 4,
    header: "What are the top cryptocurrencies?",
    text:
      "The most popular and widely heard of cryptocurrency is Bitcoin. As of early January 2021, the total cryptocurrency market is over $1 trillion, and Bitcoin is around $700 billion.",
  },
];
